import { db } from '../config/firebase';
import { doc, getDoc, runTransaction } from 'firebase/firestore';

/**
 * Generates the next invoice number in the format YYYY1000+counter
 * Retrieves the camp year from settings and last invoice number from the counter
 * Uses a transaction to ensure atomicity when incrementing the counter
 */
export const getNextInvoiceNumber = async (): Promise<string> => {
  try {
    // Get the current year from settings
    const campSettingsRef = doc(db, 'settings', 'camp');
    const campSettingsDoc = await getDoc(campSettingsRef);
    
    if (!campSettingsDoc.exists()) {
      throw new Error('Camp settings not found');
    }
    
    const campYear = campSettingsDoc.data().year;
    
    // Use a transaction to safely increment the counter
    return await runTransaction(db, async (transaction) => {
      const counterRef = doc(db, 'settings', 'invoiceCounter');
      const counterDoc = await transaction.get(counterRef);
      
      if (!counterDoc.exists()) {
        // If counter doesn't exist, initialize it
        const initialCounter = campYear * 10000 + 1000; // e.g., 20251000
        transaction.set(counterRef, { lastInvoiceNumber: initialCounter });
        return initialCounter.toString();
      }
      
      const currentCounter = counterDoc.data().lastInvoiceNumber;
      const nextCounter = parseInt(currentCounter) + 1;
      
      // Update the counter in Firestore
      transaction.update(counterRef, { lastInvoiceNumber: nextCounter });
      
      return nextCounter.toString();
    });
  } catch (error) {
    console.error('Error generating invoice number:', error);
    throw error;
  }
};

